<template>
  <div class="animated fadeIn">
    <div class="row card">
      <div class="col-md-12 col-xs-12 col-sm-12 text-center">
        <h4 class="mt-3"><b>เหตุการณ์อัพโหลดไฟล์ <i class="far fa-file-import"></i></b></h4>
        <div class="row mt-2 mr-2 ml-2">
          <div class="col-md-2 col-xs-2 col-sm-2 mb-2">
            <h5><b>ช่วงเวลาวันที่:&nbsp;</b></h5>
          </div>
          <div class="col-md-4 col-xs-4 col-sm-4 mb-2">
            <v-date-picker mode='range' v-model='picker' :input-props='{ class:"pull-right text-center form-control",style:"background: #fff; cursor: pointer; padding: 5px 10px; border: 1px solid #ccc; width: 100%", placeholder: "กรุณาเลือกช่วงเวลาของยอดขายที่ต้องการทราบ", readonly: true }'
            show-caps></v-date-picker>
          </div>
          <div class="col-md-3 col-xs-3 col-sm-3 mb-2">
            <button type="button" class="btn btn-primary form-control" v-on:click="getAPI()">
              ตรวจสอบ <i class="fas fa-search"></i>
            </button>
          </div>
          <div class="col-md-3 col-xs-3 col-sm-3 mb-2">
            <button type="button" class="btn btn-primary form-control" v-on:click="exportFromExcel()">
              XLSX <i class="far fa-download"></i>
            </button>
          </div>
        </div>
      </div>
      <div class="col-md-12 col-xs-12 col-sm-12">
        <vue-bootstrap4-table :rows="table.rows" :columns="table.columns" @refresh-data="sendAPI" :config="table.config">
          <template slot="status" slot-scope="props">
            <div class="btn btn-success text-center disabled" v-if="props.cell_value==='imported'">
              {{props.cell_value}} &#10004;
            </div>
            <div class="btn btn-primary text-center disabled" v-if="props.cell_value==='importing'">
              {{props.cell_value}} &#10070;
            </div>
            <div class="btn btn-warning text-center disabled" v-if="props.cell_value==='read_file_error'">
              {{props.cell_value}} &#10056;
            </div>
            <div class="btn btn-danger text-center disabled" v-if="props.cell_value==='write_file_error'">
              {{props.cell_value}} &#10006;
            </div>
          </template>
          <template slot="url" slot-scope="props">
            <a v-bind:href="props.cell_value" target="_blank"><button type="button" class="btn btn-primary">ดาวโหลด์ไฟล์
              <i class="fas fa-file-download"></i></button></a>
            </template>
          </vue-bootstrap4-table>
        </div>
      </div>
      <Loading :percent="load.percent" :active="load.active"></Loading>
    </div>
  </template>
  <script>
  import Vue from 'vue';
  import VCalendar from 'v-calendar';
  import 'v-calendar/lib/v-calendar.min.css';
  import XLSX from 'xlsx';
  import JWT from '../../utils/JWT.js';
  Vue.use(VCalendar);
  export default {
    components: {
      'vue-bootstrap4-table': () => import('vue-bootstrap4-table'),
      'Loading': () => import('../../utils/Loading.vue')
    },
    data() {
      return {
        alert: {
          message: ''
        },
        load: {
          task: 0,
          count: 0,
          percent: 0,
          active: false
        },
        data: {
          date: {
            start: '',
            end: ''
          }
        },
        picker: {
          start: this.$moment().toDate(),
          end: this.$moment().toDate()
        },
        table: {
          rows: [],
          config: {
            per_page: 25,
            per_page_options: [25, 50, 75, 100],
            global_search: {
              placeholder: "ค้นหา...",
            }
          },
          columns: [{
            label: "วันที่นำเข้า",
            name: "created_at",
            sort: true,
            initial_sort: true,
            initial_sort_order: "desc"
          },
          {
            label: "ชื่อไฟล์ที่นำเข้า",
            name: "file",
            sort: true,
          }, {
            label: "ประเภทไฟล์",
            name: "type",
            sort: true,
          }, {
            label: "สถานะไฟล์",
            name: "status",
            sort: true,
          }, {
            label: "วันที่อัพเดท",
            name: "updated_at",
            sort: true,
          }, {
            label: "นำเข้าโดย",
            name: "upload_by",
            sort: true,
          }, {
            label: "ดาวโหลด์ไฟล์",
            name: "url",
            sort: true,
          }
          ]
        }
      }
    },
    mounted() {
      this.getAPI();
    },
    methods: {
      resetLoading(task) {
        this.load.count = 0
        this.load.task = task
        this.load.percent = 0
        this.load.active = true
      },
      async sendAPI() {
        try {
          await this.resetLoading(1)
          const res = (await this.$http.get(process.env.VUE_APP_API_URL + 'api/v1/admin/log/import/' + await JWT.encode({
            start: this.data.date.start,
            end: this.data.date.end
          }))).body
          this.table.rows = res
          this.load.active = false
        } catch (error) {
          this.load.active = false
          if (error.body) {
            if (error.body.alert) {
              this.alert.message = error.body.alert
            } else {
              this.alert.message = 'ไม่สามารถเชื่อมต่อกับระบบได้ กรุณาตรวจสอบเครื่อข่าย'
            }
          } else {
            this.alert.message = 'ไม่สามารถเชื่อมต่อกับระบบได้ กรุณาตรวจสอบเครื่อข่าย'
          }
          this.$dialogs.alert(this.alert.message,{title: 'พบข้อผิดพลานในการส่งข้อมูล'})
        }
      },
      getAPI() {
        this.data.date = {
          'start': this.$moment(this.picker.start).format('YYYY-MM-DD'),
          'end': this.$moment(this.picker.end).format('YYYY-MM-DD')
        }
        this.sendAPI()
      },
      async exportFromExcel() {
        const data = this.table.rows;
        if (data.length > 0) {
          const wb = XLSX.utils.book_new()
          XLSX.utils.book_append_sheet(wb, await XLSX.utils.json_to_sheet(data), 'LMT Log Import')
          XLSX.writeFile(wb, 'lmt_log_import_' + await this.$moment().format('YYYY-MM-DD-H-mm-ss') + '_' + await this.$moment(this.picker
            .start).format('YYYY-MM-DD') + '_' + await this.$moment(
            this.picker
            .end).format(
            'YYYY-MM-DD') + '.xlsx')
        }
      }
    }
  }
  </script>
